import React, {
  useState,
} from "react";

import {
  ApiClientError,
} from "../api";

import {
  useAuth,
} from "../context/AuthContext";

import type {
  Id,
} from "../types";

export default function OrganizationSelection() {
  const {
    selectionSession,
    selectOrganization,
    logout,
  } =
    useAuth();

  const [
    selectedMembershipId,
    setSelectedMembershipId,
  ] =
    useState<Id | null>(null);

  const [
    loading,
    setLoading,
  ] =
    useState(false);

  const [
    error,
    setError,
  ] =
    useState<string | null>(null);

  if (!selectionSession) {
    return null;
  }

  async function choose(
    membershipId: Id
  ) {
    setSelectedMembershipId(
      membershipId
    );
    setError(null);
    setLoading(true);

    try {
      await selectOrganization(
        membershipId
      );
    } catch (caught) {
      if (
        caught instanceof
          ApiClientError
      ) {
        setError(
          caught.message
        );
      } else {
        setError(
          "No se pudo seleccionar la organización."
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card organization-selection-card">
        <div
          className="brand"
          style={{
            color: "#172a3a",
            marginBottom: 12,
          }}
        >
          MAUVELORE CRM
        </div>

        <h1>
          Elegí una organización
        </h1>

        <p className="meta">
          Hola {selectionSession.user.full_name}.
          Seleccioná el espacio en el que vas a trabajar.
        </p>

        <div className="organization-selection-list">
          {selectionSession.organizations.map(
            (access) => {
              const isLoading =
                loading &&
                String(
                  selectedMembershipId
                ) ===
                  String(
                    access.membership.id
                  );

              return (
                <button
                  key={
                    access.membership.id
                  }
                  type="button"
                  className="organization-selection-option"
                  data-organization-id={
                    access.organization.id
                  }
                  data-membership-id={
                    access.membership.id
                  }
                  disabled={loading}
                  onClick={() =>
                    choose(
                      access.membership.id
                    )
                  }
                >
                  <span className="organization-selection-name">
                    {
                      access.organization
                        .display_name
                    }
                  </span>

                  <span className="organization-selection-detail">
                    {
                      access.membership
                        .role_name
                    }
                    {" · "}
                    {
                      access.membership
                        .all_locations
                        ? "Todas las sedes"
                        : access.locations
                            .map(
                              (location) =>
                                location.name
                            )
                            .join(", ") ||
                          "Sin sedes asignadas"
                    }
                  </span>

                  <span className="organization-selection-action">
                    {isLoading
                      ? "Ingresando..."
                      : "Ingresar"}
                  </span>
                </button>
              );
            }
          )}
        </div>

        {error && (
          <div className="form-error">
            {error}
          </div>
        )}

        <button
          className="btn-ghost"
          type="button"
          disabled={loading}
          onClick={logout}
        >
          Volver al inicio
        </button>
      </div>
    </div>
  );
}
